import { FourOFour, Link } from "@hashimukh/stardust";
import React from "react";

export const NoMatch: React.FunctionComponent = () => {
    return <FourOFour>
        <p>If you&apos;re here to become a contributor, click <Link href="/registration">here</Link>.</p>
    </FourOFour>
}